import React from 'react';

const variants = {
  primary: 'btn-btc',
  secondary: 'btn-btc-outline',
  invert: 'btn-btc-outline',
};

const Button = ({
  children,
  onClick,
  href,
  variant = 'primary',
  className = '',
  type = 'button',
  ...props
}) => {
  const classes = `${variants[variant] || variants.primary} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;
